import React from 'react'
import { useCurrency } from '../../src/hooks/useCurrency'
import { useLocalization } from '../../src/hooks/useLocaleFormatter'
import { ProductPriceRangeFragment } from '../../src/model/fragments'
import { useIsVatPreferred } from '../../src/utils/useIsVatPreferred'
import { Range } from './Range'

export const PriceRange: React.FC<{ selected: ProductPriceRangeFragment | null, ranges: ProductPriceRangeFragment[], onChange: (r: ProductPriceRangeFragment | null) => void }> = 
({ selected, ranges, onChange }) => {
	const currency = useCurrency();
	const localization = useLocalization();
	const [isVatPreferred, ] = useIsVatPreferred()
	const [state, setState] = React.useState<number>(0);

	const priceRange = React.useMemo(() => {
		const applicable = localization.extractPrices(ranges);
		return applicable.length ? localization.applyPricesVAT<ProductPriceRangeFragment>(applicable, isVatPreferred)[0] : null;
	}, [ranges, isVatPreferred]);

	if(!priceRange)
	{
		return <></>;
	}

	const range = {
		min: priceRange.minCents,
		max: priceRange.maxCents
	};

	const selectedWithVAT = selected ? localization.applyPricesVAT([selected], isVatPreferred)[0] : null;
	const selectedRange = selectedWithVAT ? {
		min: Math.max(selectedWithVAT.minCents, priceRange.minCents),
		max: Math.min(selectedWithVAT.maxCents, priceRange.maxCents)
	} : null;

	React.useEffect(() => {
		if(selected)
		{
			onChange(null);
		}

		setState(state + 1);

	}, [isVatPreferred]);

	React.useEffect(() => {
		setState(state + 1);
	}, [ranges, selected]);

	return <><Range
		key={state}
		range={range}
		selected={selectedRange}
		onChange={(r) => onChange(r ? localization.removeAppliedPricesVAT([{
			...priceRange,
			minCents: r.min,
			maxCents: r.max
		}], isVatPreferred)[0] : null)}
		sliderProps={{
			currency,
		}}
	/></>
}
